import beds from '@/sui/data/sheets/beds'
import convert from '@/sui/data/sheets/convert/convert'

const info = (function () {
  function build (year) {
    function activityInfo (field) {
      const result = {
        field: 'info',
        object: [
          {
            field: 'uf',
            cfield: beds[year].uf(field)
          },
          {
            field: 'beds',
            cfield: beds[year].watchedBeds(field),
            special: 'numeric'
          },
          {
            field: 'hospit',
            cfield: beds[year].hospiDays(field),
            special: 'numeric'
          },
          {
            field: 'activeQueue',
            cfield: beds[year].activeQueueSurveillance(field),
            special: 'numeric'
          },
          {
            field: 'admissions',
            cfield: beds[year].entrances(field),
            special: 'numeric'
          },
          {
            field: 'dialysis',
            cfield: beds[year].dialysisCount(field),
            special: 'numeric'
          }
        ]
      }
      return result
    }

    return {

      establishmentDescription: {
        totalEmpty: function (value) {
          return Object.keys(value.info).length === 0
        },

        total: function (field) {
          return [
            {
              field: 'info',
              object: [
                {
                  field: 'beds',
                  cfield: beds[year].totalBeds(field),
                  special: 'numeric'
                },
                {
                  field: 'hospit',
                  cfield: beds[year].hospiDays2018(field),
                  special: 'numeric'
                },
                {
                  field: 'activeQueue',
                  cfield: beds[year].activeQueue(field),
                  special: 'numeric'
                }
              ]
            }
          ]
        },

        typeField: 'type',
        detailField: beds[year].detailBeds,

        detailEmpty: function (value) {
          return value.type == null && Object.keys(value.info).length === 0
        },

        detail: [
          {
            field: 'type',
            cfield: 'unitType',
            special: year >= 2024 ? 'unitType_v2' : 'unitType'
          },
          {
            field: 'info',
            object: [
              {
                field: 'beds',
                cfield: beds[year].bedCount,
                special: 'numeric'
              }
            ]
          }
        ]
      },

      activity: {
        totalEmpty: function (value) {
          return Object.keys(value.info).length === 0
        },

        total: function (field) {
          return [activityInfo(field)]
        },

        typeField: 'type',
        detailField: beds[year].detailSurveillance,

        detailEmpty: function (value) {
          return value.type == null && Object.keys(value.info).length === 0
        },

        detail: [
          { field: 'type', cfield: 'unitType', special: 'unitType' },
          activityInfo('')
        ]
      }
    }
  }

  return {
    '2019': build('2019'),
    '2020': build('2020'),
    '2021': build('2021'),
    '2022': build('2022'),
    '2023': build('2023'),
    '2024': build('2024'),
    '2025': build('2025'),
    '2026': build('2026')
  }
})()

function convertOccupancy (config, subfields) {
  return {
    clientToServer: function (client, server, error, op) {
      const { field, units } = op
      const result = []
      for (let i in units) {
        const u = units[i]
        const r = {}
        const ops = config.total(u.field)
        convert.clientToServer(client, r, error, ops)
        if (!config.totalEmpty(r)) {
          r[config.typeField] = u.index
          result.push(r)
        }

        if (subfields && u.subfields != null) {
          u.subfields.forEach(
            (sf) => {
              const r = {}
              const ops = config.total(sf.field)
              convert.clientToServer(client, r, error, ops)
              if (!config.totalEmpty(r)) {
                r[config.typeField] = sf.index
                result.push(r)
              }
            }
          )
        }

        const values = client[config.detailField(u.field)]
        if (values == null || values.length === 0) {
          continue
        }

        values.forEach(
          v => {
            const vr = {}
            convert.clientToServer(v, vr, error, config.detail)
            if (!config.detailEmpty(vr)) {
              result.push(vr)
            }
          }
        )
      }
      server[field] = result
    },

    serverToClient: function (client, server, error, op) {
      const { field, units } = op
      const values = server[field]
      if (values == null) {
        return
      }
      for (let i in units) {
        const u = units[i]
        const v = values.find(e => e[config.typeField] === u.index)
        if (v == null) {
          continue
        }

        const ops = config.total(u.field)
        convert.serverToClient(client, v, error, ops)
        if (subfields && u.subfields != null) {
          u.subfields.forEach(
            (sf) => {
              const sv = values.find(e => e[config.typeField] === sf.index)
              if (sv == null) {
                return
              }

              const ops = config.total(sf.field)
              convert.serverToClient(client, sv, error, ops)
            }
          )
        }

        if (u.list == null || u.list.length === 0) {
          continue
        }

        const subs = []
        for (let j in u.list) {
          const su = u.list[j]
          const sv = values.filter(e => e[config.typeField] === su.index)
          if (sv != null) {
            sv.forEach(
              e => {
                const r = {}
                convert.serverToClient(r, e, error, config.detail)
                subs.push(r)
              }
            )
          }
        }
        client[config.detailField(u.field)] = subs
      }
    }
  }
}

export default function (year) {
  return [
    { field: 'es', cfield: 'establishmentStatus' },
    { field: 'et', cfield: 'establishmentType' },
    { field: 'mat', cfield: 'hasMaternity' },
    { field: 'matt', cfield: 'maternityType' },
    { field: 'hly', cfield: 'flasks2018', special: 'numeric' },
    { field: 'hs', cfield: 'flasks2019', special: 'numeric' },
    { field: 'hly', cfield: 'hadFlasks2018', special: 'numeric' },
    { field: 'hs', cfield: 'hadFlasks2019', special: 'numeric' },
    {
      field: 'd',
      units: beds[year].allTypes,
      special: convertOccupancy(info[year].establishmentDescription, false)
    },
    {
      field: 'a',
      units: beds[year].allTypes,
      special: convertOccupancy(info[year].activity, true)
    }
  ]
}
